import React, { useEffect, useState } from 'react';
import api from '../services/api'; 
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// IMPORTAÇÕES COM OS NOVOS NOMES ESTRUTURAIS
import Hero from '../sections/Hero';
import FeaturesList from '../sections/FeaturesList';
import ProductShowcase from '../sections/ProductShowcase';
import MapLocationBlock from '../sections/MapLocationBlock';
import InfoBlock from '../sections/InfoBlock';
import InstitutionalWithLogos from '../sections/InstitutionalWithLogos';
import HorizontalTimeline from '../sections/HorizontalTimeline';
import DynamicPostFeed from '../sections/DynamicPostFeed';
import LeadCaptureForm from '../sections/LeadCaptureForm';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function Home() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // 🚀 SOLUÇÃO: Estado para armazenar e compartilhar as configurações globais (WhatsApp, etc.)
  const [siteSettings, setSiteSettings] = useState(null);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, { 
      threshold: 0.15 
    });

    const elements = document.querySelectorAll('.reveal-element, .reveal-wave, .reveal-scale');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, [sections]);

  useEffect(() => {
    api.get('/content')
      .then(res => {
        setSections(res.data.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erro na API:", err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    api.get('/settings')
      .then(res => {
        const settings = res.data;
        
        // Salva as configurações no estado para usarmos no switch abaixo
        setSiteSettings(settings);

        const root = document.documentElement;
        
        // --- APLICAÇÃO DE CORES ---
        if (settings.color_primary_1) root.style.setProperty('--cor-primaria-1', settings.color_primary_1);
        if (settings.color_primary_2) root.style.setProperty('--cor-primaria-2', settings.color_primary_2);
        if (settings.color_primary_3) root.style.setProperty('--cor-primaria-3', settings.color_primary_3);
        if (settings.color_primary_4) root.style.setProperty('--cor-primaria-4', settings.color_primary_4);
        if (settings.color_primary_5) root.style.setProperty('--cor-primaria-5', settings.color_primary_5);
        if (settings.color_sec_1) root.style.setProperty('--cor-secundaria-1', settings.color_sec_1);
        if (settings.color_sec_2) root.style.setProperty('--cor-secundaria-2', settings.color_sec_2);
        if (settings.color_sec_3) root.style.setProperty('--cor-secundaria-3', settings.color_sec_3);

        // --- APLICAÇÃO DINÂMICA DE FONTES ---
        const primaria = settings.font_primary || 'Cinzel';
        const secundaria = settings.font_secondary || 'Carattere';
        const terciaria = settings.font_terciary || 'Montserrat';

        const formatFontName = (name) => name.replace(/ /g, '+');
        
        const googleFontsUrl = `https://fonts.googleapis.com/css2?family=${formatFontName(primaria)}:wght@400;700&family=${formatFontName(secundaria)}:wght@400;700&family=${formatFontName(terciaria)}:wght@300;400;700&display=swap`;

        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.href = googleFontsUrl;
        document.head.appendChild(linkElement);

        root.style.setProperty('--fonte-primaria', `'${primaria}', serif`);
        root.style.setProperty('--fonte-secundaria', `'${secundaria}', cursive`);
        root.style.setProperty('--fonte-terciaria', `'${terciaria}', sans-serif`);

      })
      .catch(err => console.error("Erro ao carregar tema e fontes", err));
  }, []);

  if (loading) return <div className="text-center mt-5">Carregando Jurerê Blue...</div>;

  return (
    <div>
      <Navbar sections={sections} />
      
      {sections.map((section, index) => {
        let SectionComponent;

        const isRightAligned = index % 2 === 0;

        // O MOTOR DE RENDERIZAÇÃO
        switch (section.component_type) {
          case 'hero': 
            SectionComponent = <Hero section={section} />; 
            break;
          case 'features_list':
            SectionComponent = <FeaturesList section={section} isRightAligned={isRightAligned} />;
            break;
          case 'product_showcase':
            // 🔥 CORREÇÃO: Agora passa o estado 'siteSettings' que contém o WhatsApp vindo da API
            SectionComponent = <ProductShowcase section={section} isRightAligned={isRightAligned} globalSettings={siteSettings} />; 
            break;
          case 'map_location_block': 
            SectionComponent = <MapLocationBlock section={section} isRightAligned={isRightAligned} />; 
            break;
          case 'info_block':
            SectionComponent = <InfoBlock section={section} isRightAligned={isRightAligned} />;
            break;
          case 'institutional_with_logos':
            SectionComponent = <InstitutionalWithLogos section={section} isRightAligned={isRightAligned} />;
            break;
          case 'horizontal_timeline': 
            SectionComponent = <HorizontalTimeline section={section} isRightAligned={isRightAligned} />; 
            break;
          case 'dynamic_post_feed': 
            SectionComponent = <DynamicPostFeed section={section} isRightAligned={isRightAligned} />; 
            break;
          case 'lead_capture_form': 
            SectionComponent = <LeadCaptureForm section={section} isRightAligned={isRightAligned} />; 
            break;
          default:
            SectionComponent = <div className="py-5 text-center bg-light border">Nova Seção ({section.component_type}): {section.title}</div>;
        }

        return (
          <div key={section.id} style={{ position: 'relative' }}>
            {SectionComponent}
            
            {section.transition_image_url && (
              <div className="wave-container">
                <img 
                  src={`${backendUrl}${section.transition_image_url}`} 
                  alt="Transição Jurerê Blue" 
                  className="wave-img reveal-wave wave-bobbing"
                />
              </div>
            )}
          </div>
        );
      })} 
      <Footer />
    </div>
  );
}

export default Home;